

export const SITE_NOME = 'Maestro Intermediações';
export const META_TOKEN = 'IGQWRQVzdwMzFQR1EtRXJTd0RmZAGZAlYnpQWk1NUzJJMTNIU3FfSnIzanRiVzdVd2U1ZATBxWFE3QlNqaU1feGpfeFNiQWp2ZAlNxYlNTWnIxdFQ0dXh5aWlBdWxFR1VvclBfWlExSEZARaHdGbnpqUDVkMldzcUlzbncZD';
const texto = "Olá, gostaria de conhecer melhor os serviços da Maestro.";

export const MENSAGEM_WHATSAPP = `https://wa.me/5531971599490?text=${texto}`;